import useTypedSWR from 'src/components/general/useTypedSWR';
import { GET_TASKS, PatientTask } from 'src/components/pages/pageElements/tasks/getTasks.gql';

export const useTasks = (patientId: string) => {
  const { data: { tasks } = { tasks: [] }, mutate: mutateTasks } = useTypedSWR([
    GET_TASKS,
    { patientId },
  ]);

  return {
    tasks: tasks as PatientTask[], // Casting type to get more accurate flow ts type
    mutateTasks,
  };
};
